<div class="main-container lg-view">
  <h3 class="header">Procedure Summary Review</h3>
  <ng-container *ngIf="summaryReviewProcedure?.jobProcedureId">
    <h5 class="header">
      <h4>
        {{ summaryReviewProcedure.procedureName }}
      </h4>
      <h5>{{ summaryReviewProcedure.assetName }}</h5>
      <h5>{{ summaryReviewProcedure.siteAddress }}</h5>
      <button mat-raised-button (click)="handleReportAction()" class="report-button">
        {{ summaryReviewProcedure.procedureSummaryDocumentId ? 'View Report' : 'Generate Report' }}
      </button>
    </h5>
  </ng-container>
  <ng-container *ngIf="summaryReviewProcedure?.jobProcedureId == null">
    <div class="no-data-container">
      <h4 class="no-data-text">No data.</h4>
    </div>
  </ng-container>
  <ng-container
    *ngIf="summaryReviewProcedure?.jobProcedureSteps?.length"
  >
    <div class="panels-title">Steps:</div>
    <div class="procedure-steps">
      <mat-accordion>
        <mat-expansion-panel
          *ngFor="
            let step of summaryReviewProcedure.jobProcedureSteps;
            let i = index;
            trackBy: trackByJobProcedureFormId
          "
          #panel
          [expanded]="i === expandedStepIndex"
          (opened)="expandedStepIndex = i"
          [ngClass]="{
            'panel-confirmed': step.isConfirmed,
            'panel-declined': !step.isConfirmed,
            'panel-bypassed': step.isBypassed
          }"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="step-title">
              <div class="status">
                  <ng-container
                    *ngIf="step.isCompleted"
                    class="label"
                  >
                    <span>
                      <mat-icon
                        class="svg-icon"
                        [svgIcon]="'check_mark'"
                      ></mat-icon>
                    </span>
                  </ng-container>
                  <ng-container
                    *ngIf="step.isBypassed && !step.skipValidations"
                    class="label"
                  >
                    <span>
                      <mat-icon class="svg-icon" [svgIcon]="'check_mark_gray'"></mat-icon>
                    </span>
                  </ng-container>
                  <ng-container
                    *ngIf="!step.isBypassed && !step.isCompleted"
                    class="label pending"
                  >
                    <span>
                      <mat-icon
                        class="svg-icon"
                        [svgIcon]="'hourglass'"
                      ></mat-icon>
                    </span>
                  </ng-container>
              </div>
              <span><b>Step {{step.stepNumber}}. </b> <span *ngIf="!panel.expanded">{{ step.stepName }}</span></span>
            </div>
              <span class="icons-container">
                <ng-container>
                  <span [ngClass]="{'strike-icon': step.showStrikethrough, 'not-shown': !step.showBarcodeIcon }" [style.color]="ProcedureFormIconColorMap[step.barcodeIconColor]">
                    <mat-icon class="svg-icon form-icon" [svgIcon]="'barcode_status'"></mat-icon>
                  </span>
                </ng-container>
                <ng-container>
                  <span [ngClass]="{'strike-icon': step.showStrikethrough, 'not-shown': !step.pictureConfirmationRequired }" [style.color]="ProcedureFormIconColorMap[step.photoIconColor]">
                    <mat-icon class="svg-icon form-icon picture-confirmation" [svgIcon]="'field_photo'"></mat-icon>
                  </span>
                </ng-container>
                <ng-container>
                	<span [ngClass]="{'strike-icon': step.showStrikethrough, 'not-shown': !step.accessCoolOffPeriodMinutes }" [style.color]="ProcedureFormIconColorMap[step.timeConstraintIconColor]">
                    <mat-icon class="svg-icon form-icon"  style="font-size: 16px;">schedule</mat-icon>
                  </span>
                </ng-container>
                <ng-container>
                  <span [ngClass]="{'not-shown': !step.isDigitalSignatureRequired }" [style.color]="ProcedureFormIconColorMap[step.signatureIconColor]">
                    <mat-icon class="svg-icon form-icon digital-signature"  [svgIcon]="'digital_signature_status'"></mat-icon>
                  </span>
                </ng-container>
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-loader *ngIf="loadingFormId === step.jobProcedureFormId"></app-loader>
          <ng-container *ngIf="loadingFormId !== step.jobProcedureFormId">
            <div class="panel-content" [ngClass]="{'panel-bypassed': step.isBypassed}">
              <div class="step-details">
                <span>{{ step.stepName }}</span>
                <button mat-button class="link-button" (click)="goToFormDetails(step)">
                  Details
                </button>
              </div>
              <ng-container *ngIf="step.isBypassed && !step.skipValidations">
                <span class="info-badge">Bypassed</span>
                <div class="bypassed-details">
                  <span class="info-label">By:</span>
                  <span>{{ step.bypassedBy }}</span>
                </div>
              </ng-container>
              <ng-container *ngIf="step.isCompleted && !step.skipValidations">
                <div class="completion-details">
                  <div class="">
                    <span class="info-label">
                      Started:
                    </span>
                    <span>
                      {{ step.firstOpenedOn | date:'MM/dd/yyyy h:mm a' }}
                    </span>
                  </div>
                  <div class="">
                    <span class="info-label">
                      Duration:
                    </span>
                    <span>
                      {{ step.duration == null ? 'n/a' : (step.duration + ' ' + (step.duration === 1 ? 'minute' : 'minutes')) }}
                    </span>
                  </div>
                  <div class="">
                    <span class="info-label">
                      By:
                    </span>
                    <span>
                      {{ step.completedBy }}
                    </span>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="step.skipValidations">
                <span class="info-badge">Step Validation Skipped</span>
                <div class="completion-details">
                  <div class="">
                    <span class="info-label">
                      Started:
                    </span>
                    <span>
                      {{ step.firstOpenedOn | date:'MM/dd/yyyy h:mm a' }}
                    </span>
                  </div>
                  <div class="">
                    <span class="info-label">
                      Duration:
                    </span>
                    <span>
                      {{ step.duration == null ? 'n/a' : (step.duration + ' ' + (step.duration === 1 ? 'minute' : 'minutes')) }}
                    </span>
                  </div>
                  <div class="">
                    <span class="info-label">
                      By:
                    </span>
                    <span>
                      {{ step.validationsSkippedBy }}
                    </span>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </ng-container>

  <ng-container
    *ngIf="
      !summaryReviewProcedure?.jobProcedureSteps ||
      summaryReviewProcedure.jobProcedureSteps.length === 0
    "
  >
    <div class="no-data-container">
      <h4 class="no-data-text">No data.</h4>
    </div>
  </ng-container>
</div>

